import React, { FC } from 'react';
import { Col, Row } from '@sumup-oss/circuit-ui/legacy';

import {
  BottomLinksList,
  BottomLinksWrapper,
  Disclaimer,
  FooterWrapperBottom,
  SecondaryLinksItem,
  SecondaryLinksList,
  StyledAnchor,
} from '../styled';
import SocialIcons from '../SocialIcons';
import { FooterData } from '../../FooterTypes';
import { parseFooterDataUrls } from '../../FooterServices';

import { SmallGrid } from 'components/styledComponents';

type Props = {
  footerData: FooterData;
  locale: string;
};

const Component: FC<Props> = ({ footerData, locale }) => (
  <FooterWrapperBottom>
    <SmallGrid>
      <Row>
        <Col span="12" skip="0">
          <BottomLinksWrapper>
            <BottomLinksList>
              <li>
                <SecondaryLinksList>
                  {footerData?.fields?.secondaryLinks?.map((linkData) => (
                    <SecondaryLinksItem key={linkData.label}>
                      <StyledAnchor
                        size="s"
                        href={parseFooterDataUrls({
                          url: linkData.url,
                          locale,
                        })}
                      >
                        {linkData.label}
                      </StyledAnchor>
                    </SecondaryLinksItem>
                  ))}
                </SecondaryLinksList>
              </li>
              <li>
                <SocialIcons socialLinks={footerData.fields.socialLinks} />
              </li>
            </BottomLinksList>
          </BottomLinksWrapper>
        </Col>
      </Row>
      <Row>
        <Col span="12" skip="0">
          <Disclaimer size="s">{footerData.fields.disclaimer}</Disclaimer>
        </Col>
      </Row>
    </SmallGrid>
  </FooterWrapperBottom>
);

export default Component;
